import NoticeBody from './NoticeBody'
export default NoticeBody;